import React from 'react';
import ISelect from "@elements/redesign/Select/Select";
import { positiveNumberPattern } from "@utils/constants";
import { useTranslations } from 'next-intl';
import { ICountryInput } from '@types';
import TextInput from '@elements/fields/textInput';

interface PhoneFieldProps {
  countryCode: string;
  phoneNumber: string;
  countryList: ICountryInput[];
  setFieldValue: (field: string, value: any) => void;
  setFieldTouched: (field: string, touched: boolean) => void;
  errors: any;
  touched: any;
  handleBlur: any;
  isRequired?: boolean
}

const PhoneField: React.FC<PhoneFieldProps> = ({
  countryCode,
  phoneNumber,
  countryList,
  setFieldValue,
  setFieldTouched,
  errors,
  touched,
  handleBlur,
  isRequired
}) => {
  const t = useTranslations();

  return (
    <div className="w-full flex items-start gap-2 " dir="ltr">
      <ISelect
        isAuth
        onChange={(e: any) => {
          if (e !== countryCode) {
            setFieldTouched("phoneNumber", false);
            setFieldValue('countryCode', e);
            setFieldValue('phoneNumber', "");
          }
        }}
        initialCountryCode={countryCode}
        countryList={countryList}
      />

      <div className="flex flex-col flex-1">
        <TextInput
          name="phoneNumber"
          label={`${t("client_general_phonenumber")} ${isRequired ? "" : t("client_general_optional")}`}
          type='string'
          value={phoneNumber}
          error={errors.phoneNumber && touched.phoneNumber ? errors.phoneNumber : ""}
          inputMode="numeric"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const v = e.target.value;
            if (new RegExp(positiveNumberPattern, "i").test(v) || !v) {
              setFieldValue("phoneNumber", v);
            }
          }}
          onBlur={handleBlur}
        />
      </div>
    </div>
  );
};

export default PhoneField;